import React, { type ReactNode } from "react"

interface TranscriptContainerProps {
  children: ReactNode
  className?: string
}

export const TranscriptContainer: React.FC<TranscriptContainerProps> = ({
  children,
  className = "",
}) => {
  return (
    <div className={`relative z-10 ${className}`}>
      <div className="p-4 relative">{children}</div>
    </div>
  )
}
